import { render, staticRenderFns } from "./CounterArea.vue?vue&type=template&id=ac60faa6&scoped=true"
import script from "./CounterArea.vue?vue&type=script&lang=js"
export * from "./CounterArea.vue?vue&type=script&lang=js"
import style0 from "./CounterArea.vue?vue&type=style&index=0&id=ac60faa6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac60faa6",
  null
  
)

export default component.exports